// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withTranslation } from 'react-i18next';
import { ListItemIcon, List, Collapse, withStyles } from '@material-ui/core';
import Toggle from 'react-toggled';
import ReactCountryFlag from 'react-country-flag';
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';

import { EmptyIcon, styles } from './SidebarHelpers';
import { canShowFlagEmoji } from '../../utils/platform';

type Props = {
  t: Function,
  speechLang: string,
  availableLangs: any,
  setLangSelected: Function,
  classes: Object,
};

type State = {};

class LangSelector extends React.Component<Props, State> {
  selectLang = lang => {
    const { setLangSelected } = this.props;
    localStorage.setItem('speechLang', lang);
    setLangSelected(lang);
  };

  render() {
    const { speechLang, availableLangs, classes, t } = this.props;
    const langs = [];
    Object.keys(availableLangs).forEach(key => {
      langs.push({
        value: availableLangs[key].languageCode,
        key,
        flagCode: availableLangs[key].flagCode,
      });
    });

    const lang = langs.find(l => l.value === speechLang) || {};
    const currentFlagCode = lang && lang.flagCode;
    return (
      <Toggle>
        {({ on, getTogglerProps, setOff }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <ListItem key="lang_selected" button {...getTogglerProps()}>
              <ListItemIcon>
                <TextsmsOutlinedIcon />
              </ListItemIcon>
              <ListItemText style={{ paddingRight: 0 }}>
                {t('micSettings.chooseLang')}
                <br />
                {currentFlagCode && (
                  <ReactCountryFlag
                    style={{ marginRight: 5 }}
                    svg={!canShowFlagEmoji()}
                    countryCode={currentFlagCode}
                  />
                )}
                <b>{lang.key}</b>
              </ListItemText>
              <ListItemIcon style={{ marginRight: 0, minWidth: 0 }}>
                {on ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
              </ListItemIcon>
            </ListItem>
            <Collapse in={on}>
              <List>
                {langs.map(lang_ => (
                  <ListItem
                    key={lang_.value}
                    button
                    style={{
                      display: lang === lang_ ? 'none' : undefined,
                    }}
                  >
                    <EmptyIcon />
                    <ListItemText
                      classes={{ root: classes.listItemText }}
                      onClick={() => {
                        this.selectLang(lang_.value);
                        setOff();
                      }}
                    >
                      <ReactCountryFlag
                        style={{ marginRight: 5 }}
                        svg={!canShowFlagEmoji()}
                        countryCode={lang_.flagCode}
                      />
                      {lang_.key}
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </div>
        )}
      </Toggle>
    );
  }
}

export default withStyles(styles)(withTranslation()(withTheme(LangSelector)));
